module.exports = require("core-js-pure/stable/instance/trim");


//////////////////
// WEBPACK FOOTER
// ./~/@babel/runtime-corejs3/core-js-stable/instance/trim.js
// module id = 602
// module chunks = 0